import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Tooltip from '../common/Tooltip';
import './ExhibitorViewStickers.css';
import sticker_ru from './sticker-ru.png';
import sticker_en from './sticker-en.png';

const sticker = {
    ru: sticker_ru,
    en: sticker_en,
};

const ExhibitorViewStickers = ({ exhibitor }) => {
	const user = useSelector(state => state.auth.user);
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const navigate = useNavigate();

	return (
		<div>
			<h2>
				{t('exhibitorview.stickers')}
                <Tooltip>
                    <div className='ExhibitorViewStickers'>
                        <img alt='' src={sticker[lang]} width={100}/>
                        <span>{t('exhibitorview.stickers_tt')}</span>
                    </div>
			    </Tooltip>
				{(user.role === 'root' || user.role === 'admin') &&
				<span onClick={() => navigate('/cabinet/exhibitoreditstickers')}>
					{t('common.edit')}
				</span>}
			</h2>
			{exhibitor.stickers.length > 0 ?
				<ul>
				{exhibitor.stickers.map(item => (
					<li key={item._id}>
						<span
							className='sticker'
							style={{ color: item.color, background: item.background }}
						>
							{item.text[lang]}
						</span>
					</li>	
				))}
				</ul> : <div>{t('exhibitorview.nostickers')}</div>
			}
		</div>
	);
};

export default ExhibitorViewStickers;
